export const COLLAPSE_TRANSITION_LABELS_PREFERENCE_KEY =
	'jira.user.workflow.editor.collapsed.transitions';
export const TEXT_VIEW_PREFERENCE_KEY = 'jira.user.workflow.editor.list-view';
export const DEFAULT_EDITOR_PREFERENCE_KEY = 'jira.user.workflow.editor.global.scope.enrolment';
export const WORKFLOW_EDITOR_PREFERENCES_KEY = 'ADMIN_WORKFLOW_EDITOR_PREFERENCES';
export const CHANGEBOARDING_DISMISSED_PREFERENCE_KEY =
	'jira.user.workflow.editor.changeboarding-dismissed';
